export default __webpack_public_path__ + "static/media/full3.e34823cd.svg";